import { defineComponent as _defineComponent } from 'vue'
import { computed, Ref, ref, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';

import { useFilterStore } from '@/stores';
import { SelectOptionsService } from '@/services';
import { toastServiceError } from '@/services/core/notification';

import {
    AgentProductivityReportActions,
    AgentProductivityReportFilter,
    AgentProductivityReportGetters,
    LevelModel,
    SelectOptionsServiceGetUserLabelsResult,
    SelectOptionsServiceGetUsersResult,
} from '@/types';

import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentProductivityPerAgentReportFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const filterOpened = ref(false);
const suppressUserReset = ref(false);
const filter: Ref<AgentProductivityReportFilter> = ref({
    user: null,
    userLabel: null,
});
const users: Ref<SelectOptionsServiceGetUsersResult[]> = ref([]);
const userLabelOptions: Ref<SelectOptionsServiceGetUserLabelsResult[]> = ref([]);
const usersOptions = computed(() =>
    filter.value.userLabel
        ? users.value.filter((u) => u.labels.find((l) => l.id === filter.value.userLabel?.id))
        : users.value,
);

const filterStore = useFilterStore();
const levelFilter = computed<LevelModel | null>(() => filterStore.level);
const defaultFilter = computed(
    () =>
        store.getters[AgentProductivityReportGetters.DEFAULT_FILTER as keyof typeof store.getters],
);
const storeFilter = computed(
    () => store.getters[AgentProductivityReportGetters.FILTER as keyof typeof store.getters],
);

const { t } = useI18n();

watch(filterOpened, () => {
    refreshLocalFilter();
});

watch(levelFilter, () => {
    store.dispatch(AgentProductivityReportActions.CLEAR_FILTER);
    getUsers();
    getUserLabels();
});

const getUsers = async () => {
    try {
        const response = await SelectOptionsService.getUsers();
        users.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const getUserLabels = async () => {
    try {
        const response = await SelectOptionsService.getUserLabels();
        userLabelOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const applyFilters = () => {
    store.dispatch(AgentProductivityReportActions.SET_FILTER, filter.value);
};

const clearFilters = () => {
    store.dispatch(AgentProductivityReportActions.CLEAR_FILTER);
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    suppressUserReset.value = true;
    filter.value.user = storeFilter.value.user;
    filter.value.userLabel = storeFilter.value.userLabel;
    nextTick(() => {
        suppressUserReset.value = false;
    });
};

watch(
    () => filter.value.userLabel ?? null,
    (nv, ov) => {
        if (nv !== ov && !suppressUserReset.value) {
            filter.value.user = null;
        }
    },
);

onMounted(() => {
    filter.value.user = defaultFilter.value.user;
    filter.value.userLabel = defaultFilter.value.userLabel;
    getUsers();
    getUserLabels();
});

const __returned__ = { filterOpened, suppressUserReset, filter, users, userLabelOptions, usersOptions, filterStore, levelFilter, defaultFilter, storeFilter, t, getUsers, getUserLabels, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})